import React, { useEffect, useState } from "react";
import { Button, Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import "../report-category-modal/ReportCategoryModal.scss";

type Props = {
  open: boolean;
  initialName: string;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (reportName: string) => void;
};

const SaveAsReportModal: React.FC<Props> = ({
  open,
  initialName,
  loading = false,
  onClose,
  onSubmit,
}) => {
  const [reportName, setReportName] = useState(initialName);

  useEffect(() => {
    if (open) {
      setReportName(initialName);
    }
  }, [initialName, open]);

  if (!open) return null;

  const trimmedName = reportName.trim();

  return (
    <div className="gdl-category-modal gdl-modal-overlay">
      <div className="gdl-modal" role="dialog" aria-modal="true">
        <header className="gdl-modal__header">
          <h2>
            Save As
            <span className="modal-subtitle">Create a copy of this report</span>
          </h2>
          <button type="button" onClick={onClose} aria-label="Close">
            <Iconography icon="xmark" size={IconographySizes.Small} />
          </button>
        </header>

        <fieldset className="gdl-modal__body" disabled={loading}>
          <label>
            Report Name
            <input
              type="text"
              placeholder="Enter report name"
              value={reportName}
              onChange={(e) => setReportName(e.target.value)}
            />
          </label>
        </fieldset>

        <footer className="gdl-modal__footer">
          <Button label="Cancel" variant="secondary" onClick={onClose} />
          <Button
            label="Save As"
            variant="contained"
            color="primary"
            disabled={loading || !trimmedName}
            onClick={() => onSubmit(trimmedName)}
          />
        </footer>
      </div>
    </div>
  );
};

export default SaveAsReportModal;
